import * as actions from '../stores/actionsList';
import store from '../stores/storeConfig';
import HttpServices from './Http.services';
import SocketServices from './socket.services';


function init() {

    // console.log("*****init")
    SocketServices.initSocket()
    // console.log('firstinit')
    startSync()
    getHUbAccess()
    getCarts()
    // fetchMyPages()

}


function getCarts() {

    // console.log("getCarts")
    // this.setState({ isLoadingData: true })
    HttpServices.request('getCarts', {}, (fetchResult, fetchError, fetchStatus) => {

        // console.log(fetchResult)
        // this.setState({ isLoadingData: false })

        if (fetchError) {

            return
        }
        // console.log(fetchResult)
        // let headerConfig = this.state.headerConfig
        if (Array.isArray(fetchResult.carts)) {


            if (Array.isArray(fetchResult.carts)) {
                store.dispatch(actions.setCarts(fetchResult.carts))
            }

            // let carts = []

            // fetchResult.carts.forEach(cart => {

            //     let info = {
            //         info: fetchResult.cart,
            //         totalCount: fetchResult.cart?.totalCount,
            //         totalPrice: fetchResult.cart?.totalPrice
            //     }

            //     carts.push(info)

            // });



            // // console.log('My productttttttttttttttttt', fetchResult)
            // this.setState({ cart }, () => {
            //     // this.checkCart()
            //     // console.log('object', this.state.cart);
            // })
        }
    })
}




function getHUbAccess(skip = 0, tryTime = 0, limit = 20) {
    HttpServices.request('getHubAccess', { skip, limit }, (fetchResult, fetchError) => {
        // console.log('here!0002')
        if (fetchError) {
            if (tryTime < 10) {
                setTimeout(() => {
                    getHUbAccess(skip, (tryTime + 1))
                }, 20);
            }
        }
        else {
            if (fetchResult.info.length == limit) {

                store.dispatch(actions.appendHubAccess(fetchResult.info))
                setTimeout(() => {
                    getHUbAccess((skip + 1), tryTime)
                }, 20)
            }
        }

    })
}


function startSync() {
    // console.log('startSync1');
    HttpServices.request('initConfig', {}, (fetchResult, fetchError) => {
        if (fetchError) {
            return
        }

        // store.dispatch(actions.addInbox(fetchResult.info.inboxes, 'inboxes'))
        store.dispatch(actions.addConnection(fetchResult.info.connections))
        store.dispatch(actions.addRelations(fetchResult.info.relations))



        // store.dispatch(actions.appendInbox(fetchResult.info.pendingTasks, 'tasks'))
        // HttpServices.request('getMyPendingTasks', {}, (fetchResult, fetchError) => {
        //     if (fetchError) {
        //         return
        //     }
        // })
    })



    HttpServices.request('getNotifSummery', {}, (fetchResult, fetchError) => {

        // console.log("fetchError", fetchError)

        if (fetchError) {
            return
        }
        // console.log("getNotifSummery", fetchResult)
        store.dispatch(actions.addInbox(fetchResult.inboxes, fetchResult.messengers,fetchResult.hub))

    })
}


function fetchMyPages() {
    // console.log("fetchMyPages")
    HttpServices.request('getConnectedProfiles', {}, (fetchResult, fetchError, fetchStatus) => {
        // console.log("fetchError")

        // console.log(fetchError)
        // console.log(fetchResult)
        if (fetchError) {
            store.dispatch(actions.logoutUser())
            store.dispatch(actions.addNotif({ type: 'error', title: '{{lang}}errors.forceLogout', description: '{{lang}}errors.forceLogoutDesc' }))
            return
        }

        store.dispatch(actions.setPages(fetchResult.info))

        // this.setState({ profiles: fetchResult.info, pageStatus: 200 })

    })
}


export { init }